export default __webpack_public_path__ + "static/media/twitter-white.bb081ab7.svg";